export const INDEX_ROUTE = '/';
export const LOGIN_ROUTE = '/login';
export const EVENTS_ROUTE = '/events';
export const EVENTS_ADD_ROUTE = '/events/create';
export const EVENTS_EDIT_ROUTE = '/events/edit';
export const EVENTS_COPY_ROUTE = '/events/copy';
export const EVENTS_STATISTICS_ROUTE = '/events/statistics';
export const EVENTS_STATISTICS_DIRECT_RRPP_ROUTE='/events/statistics/direct-rrpp';
export const EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE='/events/statistics/referenced-rrpp';
export const EVENTS_STATISTICS_PRODUCER_ROUTE='/events/statistics/producer';
export const EVENTS_STATISTICS_GIFT_ROUTE='/events/statistics/gift';
export const EVENTS_STATISTICS_LOYALTY_ROUTE='/events/statistics/loyalty';


// export const STATISTICS_RRPP_ROUTE = '/events/statistics/rrpp'
export const TICKETS_ROUTE = '/events/tickets';
export const TICKET_ADD_ROUTE = '/events/tickets/create';
export const TICKET_EDIT_ROUTE = '/events/tickets/edit';
export const TICKET_TYPES_ROUTE = '/events/ticketTypes';
export const TICKET_TYPE_ADD_ROUTE = '/events/ticketTypes/create';
export const TICKET_TYPE_EDIT_ROUTE = '/events/ticketTypes/edit';
export const USERS_ROUTE = '/users';
export const USERS_EDIT_ROUTE = '/users/edit';

export const ROLES_ROUTE = '/roles';
export const ROLES_ADD_ROUTE = '/roles/add'
export const ROLES_EDIT_ROUTE = '/roles/edit'
export const PLACES_ROUTE = '/places';
export const PLACES_ADD_ROUTE = '/places/create';
export const PLACES_EDIT_ROUTE = '/places/edit';
export const NEWS_ROUTE = '/news';
export const NEWS_ADD_ROUTE = '/news/create';
export const NEWS_EDIT_ROUTE = '/news/edit';
export const NOTIFICATIONS_ROUTE = '/notifications';
export const NOTIFICATIONS_ADD_ROUTE = '/notifications/create';
export const NOTIFICATIONS_EDIT_ROUTE = '/notifications/edit';
export const STATISTICS_ROUTE='/stats'
export const TAGS_ROUTE='/tags'
export const TAGS_ADD_ROUTE='/tags/create'
export const TAGS_EDIT_ROUTE='/tags/edit'

export const UNAUTHORIZED_ROUTE = '/unauthorized'
// export const PASSWORD_RECOVERY = '/passwordrecovery';





// WEBPACK FOOTER //
// ./src/config/RoutesConstants.js